import { render, staticRenderFns } from "./IssuesTable.vue?vue&type=template&id=3ed04130&scoped=true&"
import script from "./IssuesTable.vue?vue&type=script&lang=js&"
export * from "./IssuesTable.vue?vue&type=script&lang=js&"
import style0 from "./IssuesTable.vue?vue&type=style&index=0&id=3ed04130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed04130",
  null
  
)

export default component.exports